// @flow
import * as React from 'react';
import { CheckBox } from 'grommet';

type Props = {
    selectAll: Boolean,
    onClick: Function,
};

const CheckboxHeader = (props: Props) => {
    const { selectAll, onClick } = props;
    return (
        <CheckBox
            checked={selectAll}
            onClick={onClick}
        />
    );
};

export default CheckboxHeader;
